var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "filter filter__container" },
      [
        _c(
          "div",
          {
            staticClass: "filter__announce-text",
            attrs: { "aria-live": "polite" },
          },
          [_vm._v(_vm._s(_vm.filterLiveMessaging))]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            ref: "popoutPanelToggleButton",
            staticClass: "filter__toggle",
            class: {
              "focus-visible": _vm.galleryVersion == "legacy",
              "filter-open": _vm.isFiltersOpen,
              "filter-closed": !_vm.isFiltersOpen,
            },
            attrs: {
              "aria-controls": "FilterPopout",
              "aria-haspopup": "dialog",
              "aria-expanded": _vm.isFiltersOpen ? "true" : "false",
              type: "button",
              tabindex: "0",
            },
            on: {
              click: function ($event) {
                return _vm.toggleFilterOpenDialog(null)
              },
            },
          },
          [
            _c("span", {
              staticClass: "desktop-show mobile-hide",
              domProps: {
                innerHTML: _vm._s(
                  _vm.getEnabledFiltersCount == 0
                    ? _vm.labels.filterToggleText
                    : _vm.labels.filterToggleWithItemsEnabledText
                ),
              },
            }),
            _vm._v(" "),
            _c("span", {
              staticClass: "mobile-show desktop-hide",
              domProps: {
                innerHTML: _vm._s(_vm.labels.filterControlsListBoxAriaLabel),
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c("Transition", { attrs: { name: "filterpanel-transition" } }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isFiltersOpen,
                  expression: "isFiltersOpen",
                },
              ],
              ref: "popoutPanel",
              staticClass: "popout",
              class: _vm.isFiltersOpen ? "popout-open" : "popout-closed",
              attrs: {
                id: "FilterPopout",
                role: "dialog",
                "aria-hidden": !_vm.isFiltersOpen,
                "aria-label": _vm.labels.filterControlsAriaLabel,
              },
              on: {
                focusout: _vm.onFocusOutOfPopup,
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape",
                    ])
                  )
                    return null
                  return _vm.toggleFilterOpenDialog(false)
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "filter__mobile-header mobile-show desktop-hide",
                },
                [
                  _c("span", {
                    staticClass:
                      "mobile-show desktop-hide filter__add-filters--xs",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.getEnabledFiltersCount == 0
                          ? _vm.labels.filterToggleText
                          : _vm.labels.filterToggleWithItemsEnabledText
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("button", {
                    ref: "filterPopupCloseButton",
                    staticClass:
                      "mobile-show desktop-hide filter__clear-filters--xs",
                    class: { "focus-visible": _vm.galleryVersion == "legacy" },
                    attrs: { type: "button", tabindex: "0" },
                    on: {
                      click: function ($event) {
                        return _vm.toggleFilterOpenDialog(false)
                      },
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "ul",
                {
                  staticClass: "filter__list",
                  attrs: {
                    "aria-hidden": _vm.isFiltersOpen ? "false" : "true",
                    "aria-label": _vm.labels.filterControlsListBoxAriaLabel,
                    role: "listbox",
                    "aria-multiselectable": "true",
                  },
                },
                [
                  _vm._l(_vm.filters, function (category, index) {
                    return _c(
                      "li",
                      {
                        key: index,
                        staticClass: "filter__list-item",
                        class: {
                          "focus-visible": _vm.galleryVersion == "legacy",
                        },
                        attrs: {
                          "aria-selected": category.enabled.toString(),
                          "aria-label": category.name,
                          role: "option",
                          tabindex: _vm.isFiltersOpen ? "0" : "-1",
                        },
                        on: {
                          keydown: (event) =>
                            _vm.onFilterKeyDown(event, category),
                          click: function ($event) {
                            return _vm.toggleFilterOption(category)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(category.name) +
                            "\n                "
                        ),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.hasMixedAssetData
                    ? _c(
                        "li",
                        {
                          staticClass: "filter__list-item",
                          class: {
                            "focus-visible": _vm.galleryVersion == "legacy",
                          },
                          attrs: {
                            "aria-selected": _vm.showImagesOnly.toString(),
                            role: "option",
                            "aria-label": _vm.labels.filterShowImagesOnlyText,
                            tabindex: _vm.isFiltersOpen ? "0" : "-1",
                          },
                          on: {
                            keydown: _vm.onShowImageOnlyKeyDown,
                            click: _vm.processShowImagesOnly,
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.labels.filterShowImagesOnlyText) +
                              "\n                "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasMixedAssetData
                    ? _c(
                        "li",
                        {
                          staticClass: "filter__list-item",
                          class: {
                            "focus-visible": _vm.galleryVersion == "legacy",
                          },
                          attrs: {
                            "aria-selected": _vm.showVideosOnly.toString(),
                            role: "option",
                            "aria-label": _vm.labels.filterShowVideosOnlyText,
                            tabindex: _vm.isFiltersOpen ? "0" : "-1",
                          },
                          on: {
                            keydown: _vm.onShowVideoOnlyKeyDown,
                            click: _vm.processShowVideoOnly,
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.labels.filterShowVideosOnlyText) +
                              "\n                "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("li", [
                    _c("div", { staticClass: "filter__footer" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "mobile-show desktop-hide btn btn--primary",
                          attrs: {
                            type: "button",
                            tabindex: _vm.isFiltersOpen ? "0" : "-1",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.toggleFilterOpenDialog(false)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.labels.filterApplyMobileButtonText))]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "mobile-hide desktop-show btn btn--primary",
                          attrs: {
                            type: "button",
                            tabindex: _vm.isFiltersOpen ? "0" : "-1",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.toggleFilterOpenDialog(false)
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.labels.filterApplyDesktopButtonText)
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn--primary-outline",
                          attrs: {
                            disabled: _vm.getEnabledFiltersCount == 0,
                            "aria-disabled": _vm.getEnabledFiltersCount == 0,
                            type: "button",
                            tabindex: _vm.isFiltersOpen ? "0" : "-1",
                          },
                          on: {
                            click: () => {
                              _vm.clearSetFilters()
                              _vm.toggleFilterOpenDialog(false)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.labels.filterClearButtonText))]
                      ),
                    ]),
                  ]),
                ],
                2
              ),
            ]
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }